import MainShaftAngularMisalignmentController from "@/controllers/wind/diagnostic/MainShaftAngularMisalignmentController.js";
import {
	GET_MAIN_SHAFT_ANGULAR_MISALIGNMENT_RESULT,
	GET_MAIN_SHAFT_ANGULAR_MISALIGNMENT_RESULT_SUCCESS,
	GET_MAIN_SHAFT_ANGULAR_MISALIGNMENT_RESULT_ERROR,
	GET_MAIN_SHAFT_ANGULAR_MISALIGNMENT_CHART,
	GET_MAIN_SHAFT_ANGULAR_MISALIGNMENT_CHART_SUCCESS,
	GET_MAIN_SHAFT_ANGULAR_MISALIGNMENT_CHART_ERROR,
	RESET_MAIN_SHAFT_ANGULAR_MISALIGNMENT_RESULT,
} from "./MainShaftAngularMisalignmentActionTypes.js";

const actions = {
	[GET_MAIN_SHAFT_ANGULAR_MISALIGNMENT_RESULT]: ({ commit }, resultSetId) => new Promise((resolve, reject) =>
	{
		commit(GET_MAIN_SHAFT_ANGULAR_MISALIGNMENT_RESULT);

		MainShaftAngularMisalignmentController.GetMainShaftAngularMisalignmentResult(resultSetId)
			.then((response) =>
			{
				commit(GET_MAIN_SHAFT_ANGULAR_MISALIGNMENT_RESULT_SUCCESS, response);
				resolve(response);
			})
			.catch((error) =>
			{
				commit(GET_MAIN_SHAFT_ANGULAR_MISALIGNMENT_RESULT_ERROR, error);
				reject(error);
			});
	}),

	[RESET_MAIN_SHAFT_ANGULAR_MISALIGNMENT_RESULT]: ({ commit }) =>
	{
		commit(RESET_MAIN_SHAFT_ANGULAR_MISALIGNMENT_RESULT);
	},

	[GET_MAIN_SHAFT_ANGULAR_MISALIGNMENT_CHART]: ({ commit }, parameters) => new Promise((resolve, reject) =>
	{
		commit(GET_MAIN_SHAFT_ANGULAR_MISALIGNMENT_CHART);

		MainShaftAngularMisalignmentController.GetMainShaftAngularMisalignmentChartData(parameters.resultSetId)
			.then((response) =>
			{
				response.isDarkMode = parameters.isDarkMode;
				commit(GET_MAIN_SHAFT_ANGULAR_MISALIGNMENT_CHART_SUCCESS, response);
				resolve(response);
			})
			.catch((error) =>
			{
				commit(GET_MAIN_SHAFT_ANGULAR_MISALIGNMENT_CHART_ERROR, error);
				reject(error);
			});
	}),
};

export default { actions };
